export const ADD_NOTE = 'notes/addNote'
export const EDIT_NOTE = 'notes/editNote'
export const GET_NOTES_BY_CONTRACT = 'notes/getByContract'
export const SET_NULL = 'notes/setNull'
export const DELETE_NOTE = 'notes/deleteNote'
